const config = {
  host: 'http://api.dev.brickspms.com/v2',
  headers: {
    'Accept': 'application/json',
    'auth-token': localStorage.getItem('token')
  },
  endpoints: [
    {
      url: 'admin/companies',
      method: 'get',
      id: 'companies',
      action: 'GET_COMPANIES',
    }
  ]
}

export default config



// WEBPACK FOOTER //
// ./src/redux/redux-api-handler/sampleConfig.js